import {
  SET_MAGAZINE,
  SET_MAGAZINES,
  ADD_MAGAZINE,
  CREATE_MAGAZINE,
  FILTER_MAGAZINES,
  EDIT_MAGAZINE,
  DELETE_MAGAZINE,
  DUPLICATE_MAGAZINE,
  TRANSFER_TEMPLATE_MAGAZINE,
  FETCH_MAGAZINES,
  EXPORTI_PDF,
  UPDATE_PDF_STATUS
} from '../types'
import { MagazinesResource } from '@/resources'

export const setMagazine = magazine => ( {
  type: SET_MAGAZINE,
  payload: magazine  
} )

export const setMagazines = magazines => ( {
  type: SET_MAGAZINES,
  payload: magazines
} )

export const addMagazine = magazine => ( {
  type: ADD_MAGAZINE,
  payload: magazine
} )

export const createMagazine = magazine => ( {
  type: CREATE_MAGAZINE,
  async: MagazinesResource.save( magazine ),
  callback: addMagazine

} )

export const filterMagazines = type => ( {
  type: FILTER_MAGAZINES,
  payload: type
} )

export const editMagazine = ( id, data ) => ( {
  type: EDIT_MAGAZINE,
  payload: { data, id },
  async: MagazinesResource.update( data, id )
} )

export const deleteMagazine = id => ( {
  type: DELETE_MAGAZINE,
  payload: id,
  async: MagazinesResource.delete( id )
} )

export const duplicateMagazine = ( id, data ) => ( {
  type: DUPLICATE_MAGAZINE,
  async: MagazinesResource.clone( id, data ),
  callback: addMagazine
} )

export const transferTemplateMagazine = ( id, data ) => ( {
  type: TRANSFER_TEMPLATE_MAGAZINE,
  async: MagazinesResource.clone( id, data )
} )

export const fetchMagazines = () => ( {
  type: FETCH_MAGAZINES,
  async: MagazinesResource.fetchAll(),
  callback: setMagazines
} )

export const toggleExportingPdf = exporting => ( {
  type: EXPORTI_PDF,
  payload: exporting
} )

export const updatePdfStatus = magazineId => ( {
  type: UPDATE_PDF_STATUS,
  payload: magazineId
} )



// WEBPACK FOOTER //
// ./src/store/actions/magazines.js